<div #componentWrapper class="advanced-select-container">
    <mat-form-field appearance="fill" class="n-search-field advanced-select-field">
        <mat-label>{{label()}}</mat-label>
        <input matInput #inputEl [disabled]="disabled()" [value]="displayValue()" (focus)="onFilterFocus()"
            [placeholder]="placeholder()" (input)="onFilterChange($event)">
        <mat-icon matSuffix (click)="!disabled() && openPanel()" tabindex="-1" class="dropdown-arrow"
            [class.open]="panelOpen()" tabindex="-1">arrow_drop_down</mat-icon>
        @if (hint()) {
        <mat-hint>{{hint()}}</mat-hint>
        }
    </mat-form-field>
    @if (showAllOrAny()) {
    <div class="n-filter-scope">
        <mat-label>Match values: all</mat-label>
        <button mat-icon-button (click)="toggleAllOrAny()">
            <mat-icon>{{ matchAll() ? 'toggle_off' : 'toggle_on'
                }}</mat-icon>
        </button>
        <mat-label>any</mat-label>
    </div>
    }
    <!-- Overlay content -->
    <ng-template #panelTemplate>
        <div class="dropdown-panel">
            @if (allowMultipleSelection() && showSelectClearAll()) {
            <div class="option clear-select-option" (click)="selectOrClearAllFilter()">
                <button matIconButton><mat-icon>clear</mat-icon></button>Select/Clear all
            </div>
            }
            @for (option of filteredOptions(); track option.value) {
            @if (option.isGroup) {
            <div class="group-option">
                <button matIconButton class="group-toggle-button" (click)="toggleGroup(option)"><mat-icon
                        [class.expanded]="isExpanded(option.label)()">keyboard_arrow_right</mat-icon></button>
                {{ option.label }}
                @for (i of option.icons; track i) {
                <mat-icon matTooltip="archived">{{i}}</mat-icon>
                }
                @if (allowMultipleSelection() && (isExpanded(option.label)())) {
                <button matIconButton class="group-clear-select-button"
                    (click)="selectOrClearAllGroup(option)"><mat-icon class="" matSuffix>{{isGroupSomeSelected(option)()
                        ? 'clear': 'done_all' }}</mat-icon></button>
                }
            </div>
            @if (isExpanded(option.label)() && option.children) {
            <div class="sublist" [class.open]="isExpanded(option.label)()">
                @for (child of option.children; track child.value) {
                @if (allowMultipleSelection()) {
                <div class="child-option" (click)="toggleOption(child.value)">
                    <mat-checkbox [checked]="selectedOptions().has(child.value)">
                        {{ child.label }}
                        @for (i of child.icons; track i) {
                        <mat-icon matTooltip="archived">{{i}}</mat-icon>
                        }
                    </mat-checkbox>
                </div>
                } @else {
                <div class="child-option no-checkbox-option" (click)="toggleOption(child.value)">
                    <div>{{ child.label }}
                        @for (i of child.icons; track i) {
                        <mat-icon matTooltip="archived">{{i}}</mat-icon>
                        }
                    </div>
                </div>
                }
                }
            </div>
            }
            }
            @else {
            @if (allowMultipleSelection()) {
            <div class="option" (click)="toggleOption(option.value)">
                <mat-checkbox [checked]="selectedOptions().has(option.value)">
                    {{ option.label }}
                    @for (i of option.icons; track i) {
                    <mat-icon matTooltip="archived">{{i}}</mat-icon>
                    }
                </mat-checkbox>
            </div>
            } @else {
            <div class="option  no-checkbox-option" (click)="toggleOption(option.value)">
                <div>{{ option.label }}
                    @for (i of option.icons; track i) {
                    <mat-icon matTooltip="archived">{{i}}</mat-icon>
                    }
                </div>
            </div>
            }
            }
            }
        </div>
    </ng-template>
</div>